// extracted by mini-css-extract-plugin
export default {"container":"jG-z","innerContainer":"kG-z","multipleLines":"lG-z","heading":"mG-z","content":"nG-z","linkColor":"oG-z"};